import { CompanyCategory } from '~domains/partner-application/entities/company-category';

export const getCategoryTitlesMap = (
  categories: CompanyCategory[]
): Record<string, string> => {
  return categories.reduce(
    (acc, categories) => {
      acc[categories.id] = categories.description;
      return acc;
    },
    {} as Record<string, string>
  );
};
